var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResetFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2643 12.0943C9.86475 12.5677 9.13525 12.5677 8.73574 12.0943L2.66076 4.8949C2.11213 4.24472 2.5743 3.25 3.42503 3.25L15.575 3.25C16.4257 3.25 16.8879 4.24472 16.3392 4.8949L10.2643 12.0943Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H11V15.9L8 18V11Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24219 16.728L16.7275 8.24275",
    stroke: "#E06E6E",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7285 16.7271L8.24323 8.24177",
    stroke: "#E06E6E",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFilter);
export default __webpack_public_path__ + "static/media/reset-filter.c4d488e7d668fecd716eac34dffe3d2e.svg";
export { ForwardRef as ReactComponent };